import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=31f3df33&scoped=true"
import script from "./Screen.vue?vue&type=script&lang=js"
export * from "./Screen.vue?vue&type=script&lang=js"
import style0 from "./Screen.vue?vue&type=style&index=0&id=31f3df33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f3df33",
  null
  
)

export default component.exports